import React, {useState, useEffect} from "react";
import dispatch from "../../../components/dispatch";
import Bin from "../../icons/Bin";
import axios from "axios";
import {
  ACTION_CART_READ,
  ACTION_REMOVE_ITEM,
  ACTION_UPDATE_CART_QUANTITY,
  ON_CART_CONTENTS_CHANGED,
  ON_CART_OPEN,
  ON_CART_UPDATE,
} from "../../globals";
import FeatherCart from "../../icons/FeatherCart";
import CloseX from "../../icons/CloseX";
import getPageType from "../../utils/getPageType";
import Cart from "../../icons/Cart";
import isLoggedIn from "../../../components/isLoggedIn";


const CartHeader = (props) => {
  const [opened, setOpened] = useState(false);
  const [total, setTotal] = useState(null);
  const [items, setItems] = useState(0);
  const [itemRecords, setItemRecords] = useState([]);
  const [checkoutLink, setCheckoutLink] = useState("");
  const loggedIn = isLoggedIn();
  const [isAu, setIsAu] = useState(false);
  const open = () => {
    setOpened(true);
    const callus = document.getElementById("msg");
    if (callus) {
      callus.setAttribute("style", "display:none");
    }
  };

  const close = () => {
    setOpened(false);
    const callus = document.getElementById("msg");
    if (callus) {
      callus.setAttribute("style", "display:block");
    }
  };

  const removeItem = (orderItem) => {
    dispatch(ON_CART_CONTENTS_CHANGED);
    axios
      .post(ACTION_REMOVE_ITEM, {
        id: orderItem.id,
        page: getPageType(),
      })
      .then((response) => {
        const data = response.data;
        dispatch(ON_CART_UPDATE, data);
      });
  };

  const decreaseQuantity = (orderItem, index) => {
    if (orderItem.quantity > 1) {
      dispatch(ON_CART_CONTENTS_CHANGED);
      axios
        .post(ACTION_UPDATE_CART_QUANTITY, {
          id: orderItem.id,
          quantity: orderItem.quantity - 1,
          page: getPageType(),
        })
        .then((response) => {
          const data = response.data;
          dispatch(ON_CART_UPDATE, data);
        });
    }
  };

  const increaseQuantity = (orderItem, index) => {
    dispatch(ON_CART_CONTENTS_CHANGED);
    axios
      .post(ACTION_UPDATE_CART_QUANTITY, {
        id: orderItem.id,
        quantity: orderItem.quantity + 1,
        page: getPageType(),
      })
      .then((response) => {
        const data = response.data;
        dispatch(ON_CART_UPDATE, data);
      });
  };

  useEffect(() => {
    const bindActions = () => {
      window.addEventListener(ON_CART_UPDATE, (e) => {
        const data = e.data;
        setIsAu(data.is_au_site || false);
        if (data.empty === 1) {
          setTotal(null);
          setItems(0);
          setItemRecords([]);
          setCheckoutLink("");
        } else {
          setTotal(data.items_total);
          setItems(data.items);
          setItemRecords(data.item_records);
          setCheckoutLink(data.cart_link);
        }
      });
    };

    bindActions();
    loadCartContents();

    window.addEventListener(ON_CART_OPEN, open);

    return () => {
      window.removeEventListener(ON_CART_OPEN, open);
    };
  }, []);

  const loadCartContents = () => {
    axios.get(ACTION_CART_READ).then((response) => {
      const data = response.data;
      dispatch(ON_CART_UPDATE, data);
    });
  };

  const redirectToCart = () => {
    if (items > 0) {
      window.location.href = checkoutLink;
    }
  };

  return (
    <>
    {(loggedIn || items > 0) && (
      <div className="header-cart">
        {/* {!!total && (
          <span className="header-cart__price">{total} incl. GST</span>
        )} */}
        <div className="header-cart__icon-section" onClick={open}>
          <Cart/>
          <span className="header-cart__number">{items}</span>
          <span className="header-cart__test">Cart</span>

        </div>
      </div>
    )}
      {items > 0 && (
        <div className={`header-cart-popup ${opened ? "active" : ""}`}>
          <div className={"header-cart-popup__bg"} onClick={close}></div>
          <div className={"header-cart-popup__contents"}>
            <div className={"header-cart-popup__close"} onClick={close}>
              <CloseX/>
            </div>
            <div className={"header-cart-popup__items"}>
              <ul>
                {itemRecords.map((orderItem, index) => (
                  <li
                    key={`order_item__${orderItem.id}`}
                    className="header-cart-popup__item"
                  >
                    <div className="header-cart-popup__item-image-wrapper">
                      <a
                        href={orderItem.link}
                        className="header-cart-popup__item-image"
                        style={{
                          backgroundImage: `url("${orderItem.image}")`,
                        }}
                      ></a>
                    </div>
                    <div className="header-cart-popup__item-content">
                      <div className={"header-cart-popup__item-title"}>
                        <h6>
                          <a href={orderItem.link}>{orderItem.title}</a>
                        </h6>
                        <p>
                          {orderItem.sku}
                          <br/>
                          (Size: {orderItem.size} Colour: {orderItem.color})
                        </p>
                      </div>

                      <div className="header-cart-popup__item-total">
                        <div className={"header-cart-popup__item-quantity"}>
                          {((!!props.editable && !props.sample_order)|| isAu) ? (
                            <div className="count-section">
                              <span
                                className="count-icon"
                                onClick={() => {
                                  decreaseQuantity(orderItem, index);
                                }}
                              >
                                &#8722;
                              </span>
                              <span className="count">
                                {orderItem.quantity}
                              </span>
                              <span
                                className="count-icon"
                                onClick={() => {
                                  increaseQuantity(orderItem, index);
                                }}
                              >
                                &#43;
                              </span>
                            </div>
                          ) : (
                          // {(!props.editable || !!props.sample_order)  &&
                            <div className="count-section">
                              <span className="count-icon disabled">
                                &#8722;
                              </span>
                            <span className="count">
                                {orderItem.quantity}
                              </span>
                            <span className="count-icon disabled">&#43;</span>
                          </div>
                          )}

                        </div>
                        <div className={"header-cart-popup__item-total"}>
                          {orderItem.total}
                        </div>
                      </div>
                    </div>
                    {props.editable && (
                      <div className="header-cart-popup__remove">
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            removeItem(orderItem);
                            return false;
                          }}
                        >
                          <Bin/>
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="header-cart-popup__total">
              <span>Total </span> <span>{total}</span>
            </div>
            <div className="header-cart-popup__btns">
              <a
                href={checkoutLink}
                className="btn btn--black btn--not-bg-icon"
              >
                <FeatherCart/>
                Proceed to checkout
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CartHeader;
